/** DOM contract shared by RML attachment drops and RCL post drops. */ const FOLDER_TREE_DROPPABLE_NODE_SELECTOR = ".aiot-node.aiot-droppable";
/** jQuery UI `droppable` classes — styled in `style/style.scss`. */ const FOLDER_TREE_DROP_ACTIVE_CLASS = "aiot-drop-active";
const FOLDER_TREE_DROP_HOVER_CLASS = "aiot-drop-hover";
function bindJqueryFolderTreeDroppable({ $, root, nodeSelector = FOLDER_TREE_DROPPABLE_NODE_SELECTOR, activeClass = FOLDER_TREE_DROP_ACTIVE_CLASS, hoverClass = FOLDER_TREE_DROP_HOVER_CLASS, tolerance = "pointer", onDrop }) {
    const $root = typeof root === "string" ? $(root) : $(root);
    const dom = $root.find(nodeSelector);
    if (!dom.length) {
        return;
    }
    try {
        dom.droppable("destroy");
    } catch  {
    // jQuery UI throws when droppable was not initialised.
    }
    dom.droppable({
        activeClass,
        hoverClass,
        tolerance,
        drop: onDrop
    });
}
export { bindJqueryFolderTreeDroppable, FOLDER_TREE_DROP_ACTIVE_CLASS, FOLDER_TREE_DROP_HOVER_CLASS, FOLDER_TREE_DROPPABLE_NODE_SELECTOR };
